import { RegisterCard } from "../../components/RegisterCard";
import { TimeSelect } from "../../components/TimeSelect";
import { CircleLoader } from "../../components/CircleLoader";
import { Clock, Baby, FileText, Check } from "lucide-react";

export const CAtoilet = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const toiletTypes = ["diaper", "underwear", "potty", "no pee"];

  return (
    <div className="w-full max-w-4xl mx-auto p-4 animate-in slide-in-from-bottom-4 duration-500">
      <RegisterCard
        title="Potty & Diaper"
        details="Keep track of bathroom breaks and changes."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-6 sm:p-10 space-y-8 order-2 lg:order-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Time Selection */}
            <div className="space-y-3">
              <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                <Clock size={14} className="text-blue-500" /> Time
              </label>
              <div className="h-14 border-2 border-slate-100 rounded-2xl bg-slate-50 flex items-center px-4">
                <TimeSelect
                  value={formData.time ?? "09:00"}
                  onChange={(val: string) => onFormChange("start_time", val)}
                />
              </div>
            </div>

            {/* Type Selection */}
            <div className="space-y-3">
              <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
                <Baby size={14} className="text-blue-500" /> Type
              </label>
              <div className="grid grid-cols-2 gap-2">
                {toiletTypes.map((type) => (
                  <button
                    key={type}
                    type="button"
                    onClick={() => onFormChange("toilet_type", type)}
                    className={`py-2 px-3 rounded-xl border font-bold text-[13px] capitalize transition-all
                      ${formData["toilet_type"] === type ? "bg-blue-50 border-blue-500 text-blue-700" : "bg-white border-slate-200 text-slate-400"}`}
                  >
                    {type}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Description */}
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <FileText size={14} className="text-blue-500" /> Description
            </label>
            <textarea
              name="description"
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              placeholder="Any additional observations (e.g. stool consistency, rash)..."
              className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-[1.5rem] min-h-[120px] focus:bg-white focus:border-blue-500 transition-all outline-none resize-none shadow-inner"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-blue-600 hover:bg-blue-700 text-white rounded-2xl font-black uppercase tracking-widest shadow-lg shadow-blue-200 transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <Check size={20} /> Add Activity
              </>
            )}
          </button>
        </div>

        {/* Visual Sidebar */}
        <div className="lg:w-64 bg-blue-50 flex items-center justify-center p-8 order-1 lg:order-2 border-b lg:border-b-0 lg:border-l border-slate-100">
          <img
            src="/img/public-toilet.svg"
            className="w-32 h-32 lg:w-48 lg:h-48 drop-shadow-xl"
            alt="toilet"
          />
        </div>
      </form>
    </div>
  );
};
